import { Button, Row } from "antd";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { ROUTER_PATH, WIDTH_IPAD } from "../../common/constant";
import "./style.scss";
import _ from "lodash";
import { localizeRouteKey } from "../../shared/helpers";
import { eventImageService } from "../../services";
import { IEventImageDetailModel } from "../../models/interface";
import ResponsiveImage from "../ResponsiveImage";

const EventImages = (props: any) => {
  const { sectionItem, history } = props;
  const { innerWidth } = window;
  const [eventImages, setEventImages] = useState<IEventImageDetailModel[]>([]);
  const [loading, setLoading] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: innerWidth > WIDTH_IPAD ? 2 : 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  // Fetch event images for home page
  useEffect(() => {
    const fetchEventImages = async () => {
      setLoading(true);
      try {
        const data = await eventImageService.getEventImageDetailsForHomePage({
          limit: 10,
        });
        if (data) {
          setEventImages(data);
        }
      } catch (error) {
        console.error("Error fetching event images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEventImages();
  }, []);

  const showSlide = (data: IEventImageDetailModel[]) =>
    data.map((item: IEventImageDetailModel, i: number) => (
      <div key={item._id || i}>
        <ResponsiveImage
          mediaId={item.picture_id}
          mobileMediaId={item.mobile_picture_id}
          alt={item.caption}
          style={{ width: "100%", objectFit: "cover" }}
        />
        <div className="location-title">
          <div className="event-info">
            <span style={{ fontWeight: "bold" }}>
              {`${item.year} - ${item.caption}`}
            </span>
            <br />
            {item.name && <span>{item.name}</span>}
          </div>
        </div>
      </div>
    ));

  // Don't render if no event images or still loading
  if (loading || !eventImages || eventImages.length === 0) {
    return null;
  }

  return (
    <div className="kd-section-event-images">
      <div className="slide-text-wrap">
        <Row className="main-title">
          {sectionItem?.title || "HÌNH ẢNH SỰ KIỆN"}
        </Row>
        <Row>
          <Button
            onClick={() => history.push(localizeRouteKey(ROUTER_PATH.EVENT))}
            className="see-all-btn">
            Xem tất cả
          </Button>
        </Row>
      </div>
      <Slider {...settings} className="images-slider">
        {showSlide(
          _.sortBy(
            eventImages.filter(
              (item: IEventImageDetailModel) => item.is_activated
            ),
            ["order"]
          )
        )}
      </Slider>
    </div>
  );
};

export default EventImages;
